import React, { useState, useContext, createRef, useEffect } from 'react'
import { Button, Divider, Form, Grid, Header, Image, Message, Segment, Sticky } from 'semantic-ui-react';
import { Link, Redirect } from 'react-router-dom';
import { AppState } from '../context';
// import Cookies from 'js-cookie';

const LoginForm = ({inst}) => {
  const someContext = useContext(AppState);
  const [error, setError] = useState(false);
  const [pass, setPass] = useState("");
  const [username, setUsername] = useState("");
  const {
    firsttimeuser,
    setFirsttimeuser,
    setUser,
    globallogged,
    setGlobalLogged,
    logged,
    setLogged,
    familyMembers,
  } = someContext;

  const contextRef = createRef();
  function CheckPass(pass, username) {
    console.log(username)
    if (familyMembers[username]) {
      if (familyMembers[username]["password"] === pass && familyMembers[username]["type"] === "primary") {
        // Cookies.set('logged', {username: familyMembers[username]["id"], password: familyMembers[username]["password"]}, { expires: 1 });
        setGlobalLogged(true);
        setUser(username)
      }
      else if (familyMembers[username]["password"] === pass && familyMembers[username]["type"] === "secondary") {
        setLogged(true);
        setUser(username);
      }

      else if (pass && username) {
        setError(true)
      }
    }
    else if (pass && username) {
      setError(true)
    }
  }

  function redirect() {
    if (globallogged == true) {
      return  <Redirect to={`/familymembers/summary/${username.value}`} push={true} />
    }
    else if (logged == true) {
      // return inst ?   <Redirect to={`/${inst}/viewfamily/${username.value}`} push={true} /> : 
      return  <Redirect to={`/viewfamily/${username.value}`} push={true} />
    }
  }
  return (<div ref={contextRef}>
    <Sticky context={contextRef} >
      <div>
        <Divider hidden />
        <Divider hidden />
        <Divider hidden />
        <Divider hidden />
        <Divider hidden />
        <Divider hidden />
        <Divider hidden />

      </div>
      <Grid textAlign='center' style={{ height: '100vh' }} padded>

        <Grid.Column style={{ maxWidth: 450 }}>
          <Header as='h2' color='teal' textAlign='center'>
            <Image src={inst == "Samarth" ? "/samarth.png" :'/logo192.png'} /> Log-in to your account
    </Header>
          <Form size='large' warning={error}>
            <Segment stacked>
              <Form.Input fluid icon='user' required iconPosition='left' onChange={(e) => { setUsername({ value: e.target.value }) }} placeholder='Username' />
              <Form.Input
                onChange={(e) => { setPass({ value: e.target.value }) }}
                fluid
                required
                icon='lock'
                iconPosition='left'
                placeholder='Password'
                type='password'
              />

              <Form.Button color='teal' fluid size='large' onClick={() => CheckPass(pass.value, username.value)}>
                Login
        </Form.Button>
            </Segment>
            <div style={{ maxWidth: 450 }}>
              <Message
                warning
                floating
                content="Your username or password dones't match our records."
                size="tiny"
              />
            </div>
          </Form>
          <Message>
            New to us? {!inst ? <a href='/signup'>Sign Up</a> :  ""}
            {/* <a href=`/${inst}/signup`>Sign Up with {inst}</a> */}
          </Message> 
        </Grid.Column>
      </Grid>
      {username ? redirect() : ""}

    </Sticky>
  </div>
  )
}

export default LoginForm